<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { Editor, EditorContent } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import { BlockEditor, BubbleMenu } from '@/Components/Inputs/BlockEditor/Extension'
import Toolbar from '@/Components/Inputs/BlockEditor/Toolbar.vue'
import Link from '@tiptap/extension-link'
import { TextAlign } from '@tiptap/extension-text-align'
import ResizablePreview from '../../ResizablePreview.vue'

const props = defineProps({
  enabled: {
    type: Boolean,
    default: false,
  },
  content: {
    type: String,
    default: '',
  },
  contentData: {
    type: Object,
    default: {},
  },
  editorData: {
    type: Object,
    default: {},
  },
})

const editor = ref(null)

const editorElement = ref(null)

watch(() => props.content, (newContent) => {
  if (editor.value) {
    editor.value.commands.setContent(newContent)
  }
}, { immediate: true })

onMounted(() => {
  editor.value = new Editor({
    extensions: [
      StarterKit,
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
      BlockEditor.configure({
        editorData: props.editorData,
        contentData: props.contentData,
      }),
      Link.configure({
        openOnClick: false,
        HTMLAttributes: {
          class: 'text-blue-500',
        },
      }),
    ],
    editorProps: {
      attributes: {
        class: 'overflow-hidden !max-w-full w-full prose prose-img:m-0 !border-none !p-0'
      },
    },
    content: props.content,
    editable: false,
  })
})
</script>

<template>
  <EditorContent v-if="enabled && editor && content" ref="editorElement" :editor="editor" class="h-full w-full" />
</template>
